export enum CropperDragModeOptions {
  DRAG = 'drag',
  CROP = 'crop',
  NONE = 'none',
}

export interface CropperPanelHelperTooltip {
  message: string;
  hideTooltipAfterSeconds?: number;
  showTooltipAfterSeconds?: number;
}

export interface CropperPanelApplyResponse {
  cropData: CropData;
  isBackgroundRemoved: boolean;
}

export interface CropData {
  x: number;
  y: number;
  width: number;
  height: number;
  imageWidth: number;
  imageHeight: number;
}
